import { ref } from 'vue';
import { CouponInfo } from '@tencent/wphk-components-wecoupon';
import { CustomException } from '@tencent/ppd-base-libs';
import { getCouponInfoByCouponIds } from '@tencent/wphk-components-wecoupon/components/theme/api';
import { resolveCouponInfoArray } from '@tencent/wphk-components-wecoupon/components/mch-coupon-list/business/coupon';
import { to } from '@tencent/wphk-base-utils';
import { ERouterName } from '@/config';
import { useRouter } from 'vue-router/composables';
import { hideDialog, showDialog } from '@tencent/wphk-components-dialog';
import { i18n } from '@/i18n';
import { hideLoading, showLoading } from '@tencent/wphk-act-base-ui';

/** 券信息 */
const couponInfo = ref<CouponInfo | null>(null);
export const useCouponDetail = () => {
  /** 查询券信息 */
  async function initCouponDetail(couponId: string) {
    const router = useRouter();
    if (!couponId) {
      // 跳转到商户首页
      router.replace({
        name: ERouterName.home,
      });
      return;
    }
    // 查询券信息
    showLoading();
    const [err, couponArray] = await to(getCouponInfoByCouponIds([couponId]));
    hideLoading();
    if (err || !couponArray) {
      new CustomException(err, 'initCouponDetailFail', `查询券信息失败[${couponId}]`);
      return;
    }
    if (couponArray.length === 0) {
      // 券不存在（下架/id不存在）
      // 跳转到首页并且提示
      showDialog({
        content: i18n('優惠已經派完啦，去睇睇其他優惠！'),
        btns: [{
          text: i18n('我知道了'),
          click: () => {
            hideDialog();
          },
        }],
      });
      router.replace({
        name: ERouterName.home,
      });
      return;
    }
    const result = resolveCouponInfoArray(couponArray!);
    // 取第一个元素（理论上也只有一个元素）
    [couponInfo.value] = result;
  }
  /** 更新couponInfo(领券之后要更新couponInfo信息) */
  function updateCouponInfo(params: Object) {
    couponInfo.value = Object.assign({}, couponInfo.value, params);
  }

  return {
    initCouponDetail,
    updateCouponInfo,
    couponInfo,
  };
};
